module.exports = "https://web-assets-production.autolist.com/_next/static/images/hatchback-5f9398553078043594c2da42b2b7843f.png";